import React, { FC, Fragment } from "react";

import { useLeasingStateContext } from "../../../../contexts/leasing/context/leasing.context";
import { ProductPageStockFilters } from "../../../../contexts/leasing/types/leasing.types";
import * as Styles from "../leasing-modal-hub.styled";

export const LeasingAllOptionsInStockModal: FC = () => {
  const { selectedStockFilter } = useLeasingStateContext();
  const viewingInStockOffers =
    selectedStockFilter === ProductPageStockFilters.IN_STOCK;
  return (
    <Fragment>
      <Styles.LeasingProductModalHeaderAndParagraphContainer>
        <Styles.LeasingProductModalHeader>
          In stock
        </Styles.LeasingProductModalHeader>
        <Styles.LeasingProductModalParagraph>
          When it&apos;s available, selecting &lsquo;In-stock options
          only&rsquo; will show you vehicle options that are ready to be
          delivered soon.
        </Styles.LeasingProductModalParagraph>
        <Styles.LeasingProductModalParagraph>
          Prices for in-stock options tend to be lower than factory order
          vehicles, and delivery times are usually more accurate.
        </Styles.LeasingProductModalParagraph>
      </Styles.LeasingProductModalHeaderAndParagraphContainer>
      {viewingInStockOffers ? (
        <Styles.LeasingProductModalHeaderAndParagraphContainer>
          <Styles.LeasingProductModalHeader>
            In no hurry?
          </Styles.LeasingProductModalHeader>
          <Styles.LeasingProductModalParagraph>
            If you don&apos;t mind waiting a little longer, you can also choose
            factory order options. These vehicles will be finished at the
            factory to your chosen specification, and delivered straight to you
            from the manufacturer.
          </Styles.LeasingProductModalParagraph>
          <Styles.LeasingProductModalParagraph>
            Factory order vehicles are usually priced slightly higher than
            in-stock options because they are finished to order.
          </Styles.LeasingProductModalParagraph>
        </Styles.LeasingProductModalHeaderAndParagraphContainer>
      ) : null}
    </Fragment>
  );
};
